import Mustache, { parse, render } from 'mustache';
import lodash from 'lodash';
import DataType from 'complionAdmin/components/BinderTemplateQuery/DataType/DataType';
import moment from 'moment';

Mustache.escape = value => value;

export function calculateAutonameValue({
    document,
    documentType,
    descriptors,
    institutionTimezone
}) {
    if (!documentType) {
        return '';
    }
    const { autonameTemplate } = documentType;
    if (!autonameTemplate) {
        return '';
    }
    const data = {
        system: document,
        documentType,
        descriptors
    };
    const parsedAutoname = parse(autonameTemplate);
    const parsedValues = lodash.chain(parsedAutoname)
        .map(([name, propertyPath]) => {
            if (name === 'text') return propertyPath;
            try {
                return [propertyPath, getValueFromAutonameProperty(propertyPath, data, institutionTimezone)];
            } catch (e) {
                return [propertyPath, ''];
            }
        }).reduce((values, [propertyPath, value]) => {
            lodash.set(values, propertyPath, value);
            return values;
        }, {})
        .value();
    return render(autonameTemplate, parsedValues);
}

const typeHandlers = {
    system: handleSystemProperty,
    documentType: handleDocumentTypeProperty,
    descriptor: handleDescriptorProperty
};

function getValueFromAutonameProperty(propertyPath, data, institutionTimezone) {
    let [type, key, property] = propertyPath.split('.');
    key = handleSpecialKeys(key);
    const handler = typeHandlers[type];
    if (typeof handler !== 'function') {
        throw new Error(`Unknown type ${type}. Cannot use for autonaming.`);
    }
    if (type === 'descriptor') {
        return handler(data, key, property, institutionTimezone);
    }
    return handler(data, key, property);
}

function handleSpecialKeys(key) {
    if (key === 'originalFilename') {
        return 'name';
    }
    return key;
}

function handleSystemProperty(data, ...path) {
    const sanitizedPath = lodash.filter(path, value => !lodash.isNil(value));
    return lodash.get(data, ['system', ...sanitizedPath]);
}

function handleDocumentTypeProperty(data, key, property) {
    return lodash.get(data, ['documentType', key]);
}

function handleDescriptorProperty(data, key, property, institutionTimezone) {

    const descriptorsByName = lodash.keyBy(data.descriptors, 'name');
    let value = lodash.get(descriptorsByName, [key, property]);
    if (property === 'value') {
        //transform according to dataType
        const dataType = lodash.get(descriptorsByName, [key, 'dataType']);
        if (lodash.isArray(value)) {
            value = lodash.map(value, v => getRawValuesByDatatype(dataType, v, institutionTimezone));
        } else {
            value = getRawValuesByDatatype(dataType, value, institutionTimezone);
        }
    }
    return value;
}

function isDateType(type) {
    const comparableType = type.toLowerCase();
    return comparableType === 'datetime' || comparableType === 'dateonly';
}

function formatDateType(type, value, institutionTimezone) {
    const comparableType = type.toLowerCase();
    if (comparableType === 'datetime') {
        return moment(value).utcOffset(institutionTimezone).format('DD MMM YYYY');
    } else {
        return moment(value).format('DD MMM YYYY');
    }
}

function getRawValuesByDatatype(dataType, value, institutionTimezone) {
    const val = DataType.getRawValue(dataType, value);
    return isDateType(dataType) ? formatDateType(dataType, val, institutionTimezone) : val;
}